module.exports = __webpack_public_path__ + "static/4-02f86a99f498394f3acf275d2168799a.jpeg";